<template>
  <div @click="select(item.id)">
    <div>
      <h2 class="title">{{ item.title }}</h2>
      <v-icon class="help">mdi-account-question</v-icon>
    </div>
    <article class="dropTarget">
      <!-- Card gets dropped into here -->
    </article>
    <div class="information" v-if="selected">
      <div>
        <h2 class="title">{{ item.title }}</h2>
        <v-icon class="help" @click="select(item.id)">mdi-close-circle</v-icon>
      </div>
      <div>
        <p class="overline">Goal</p>
        {{ item.goal }}
        <p class="overline">Strategy</p>
        {{ item.strategy }}
        <p class="overline">Fear</p>
        {{ item.fear }}
        <p class="overline">Personalities</p>
        {{ item.personalities }}
        <p class="overline">Attributes</p>
        {{ item.attributes }}
        <p class="overline">Brands</p>
        {{ item.brands }}
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "ArchetypesCard",
  props: {
    item: Object,
  },
  data() {
    return {
      selected: false,
    };
  },
  methods: {
    select(id) {
      this.selected = !this.selected;
      this.$emit("selectNote", id, this.selected);
    },
  },
};
</script>

<style lang="scss">
.information {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 4;
  color: white;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  pointer-events: none;
}
.dropTarget {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  pointer-events: none;
  .drag-el {
    pointer-events: auto;
  }
}
</style>
